import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import { format } from 'date-fns'
import { useState } from 'react'
import classes from './adminSinglePost.module.css'
import { Modal, Button } from 'antd'

const AdminSinglePost = ({ post, type }) => {
  const navigate = useNavigate()
  const [isDelModalVisible, setIsDelModalVisible] = useState(false)
  const axiosPrivate = useAxiosPrivate()
  const formatedDate = format(new Date(post.createdAt), 'dd-MM-yyyy HH:mm:ss')

  let path
  let func

  if (type === 'betKursNovo') {
    path = ''
    func = 'deleteBetKursNovoPost'
  } else if (type === 'help') {
    path = ''
    func = 'helpitem'
  } else if (
    type === 'betcourse' ||
    type === 'betsystem' ||
    type === 'betstrategy'
  ) {
    path = ''
    func = 'deleteBetCoursePost'
  } else if (type === 'infoBlok') {
    path = ''
    func = 'deleteInfoBlokPost'
  } else if (type === 'bet_portal' || type === 'leagues') {
    path = ''
    func = 'deleteBetPortalPost'
  } else if (type === 'statistika') {
    path = ''
    func = 'deleteStatistikaPost'
  } else if (type === 'nasiPredlozi') {
    path = ''
    func = 'deleteNasiPredloziPost'
  } else if (type === 'betKalkulatoriTutorijal') {
    path = ''
    func = 'deleteBetKalkulatoriTutorijalPost'
  } else if (type === 'pomocSekcija') {
    path = ''
    func = 'helpsection'
  } else if (
    type === 'betKursPoglavlje' ||
    type === 'betSistemPoglavlje' ||
    type === 'betStrategijePoglavlje'
  ) {
    path = ''
    func = 'betcoursechapter'
  } else if (type === 'korisnickiPaketi') {
    path = ''
    func = 'users-package'
  }

  const deletePostMutation = useMutation({
    mutationFn: () =>
      axiosPrivate.delete(`${path}/${func}`, {
        data: { postId: post._id },
      }),
  })

  if (deletePostMutation.isLoading) return <h1>Loading...</h1>
  if (deletePostMutation.isError) return <h1>Error...</h1>

  const handleIzmeni = () => {
    if (type === 'betKalkulatoriTutorijal') {
      navigate('/betko-admin/edituj-post-tutorijal', {
        state: { postId: post._id, type },
      })
    } else if (type === 'help') {
      navigate('/betko-admin/edituj-pomoc-post', {
        state: { postId: post._id, type },
      })
    } else if (type === 'calculator') {
      navigate('/betko-admin/edituj-kalkulator-tutorijal-post', {
        state: { postId: post._id, type },
      })
    } else if (type === 'betcourse') {
      navigate('/betko-admin/edituj-post-betkurs', {
        state: { postId: post._id, type },
      })
    } else if (type === 'betsystem') {
      navigate('/betko-admin/edituj-post-betsistem', {
        state: { postId: post._id, type },
      })
    } else if (type === 'betstrategy') {
      navigate('/betko-admin/edituj-post-betstrategije', {
        state: { postId: post._id, type },
      })
    } else if (type === 'korisnickiPaketi') {
      navigate('/betko-admin/edituj-post-korisnickipaketi', {
        state: { postId: post._id, type },
      })
    } else {
      navigate('/betko-admin/edituj-post', {
        state: { postId: post._id, type },
      })
    }
  }
  const handleObrisi = () => {
    deletePostMutation.mutate(post._id)

    window.location.reload()
  }

  return (
    <div className={classes.singlePost}>
      <div className={classes.left}>
        <p>
          <span className={classes.title}>Modifikovan:</span>
          {formatedDate}
        </p>
        |
        <p>
          <span className={classes.title}>Naslov:</span>
          {post.title.length >= 38
            ? post.title.substring(0, 38) + '...'
            : post.title}
        </p>
      </div>
      <div className={classes.right}>
        {![
          'pomocSekcija',
          'calculatorTutorijal',
          'betKursPoglavlje',
          'betSistemPoglavlje',
          'betStrategijePoglavlje',
        ].includes(type) && (
          <div>
            {' '}
            <button className={classes.btn} onClick={handleIzmeni}>
              Izmeni
            </button>
            {!['calculator', 'calculatorTutorijal'].includes(type) && '|'}
          </div>
        )}
        {!['calculator', 'calculatorTutorijal'].includes(type) && (
          <button
            className={classes.btn}
            onClick={() => {
              setIsDelModalVisible(true)
            }}
          >
            Obriši
          </button>
        )}
      </div>

      <Modal
        footer={[]}
        open={isDelModalVisible}
        title='Da li ste sigurni da želite da obrišete post?'
        onCancel={() => {
          setIsDelModalVisible(false)
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-evenly',
            marginTop: '20px',
          }}
        >
          <Button
            onClick={(e) => {
              handleObrisi()
              setIsDelModalVisible(false)
            }}
          >
            Obriši
          </Button>
          <Button
            onClick={(e) => {
              setIsDelModalVisible(false)
            }}
          >
            Odustani
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default AdminSinglePost
